export default __webpack_public_path__ + "static/media/Alison_Chantal_664X830.70361f19.jpg";